/* Loft Home — predictive search + wishlist */
(function () {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const money = (c) => (window.LoftMoney ? window.LoftMoney(c) : '£' + (c / 100).toFixed(2));
  const esc = (s) => String(s || '').replace(/[&<>"]/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]));

  /* ---------- Predictive search ---------- */
  const input = $('#HeaderSearchInput');
  if (input) {
    const panel = document.createElement('div');
    panel.className = 'predictive page-width';
    panel.setAttribute('role', 'region');
    panel.setAttribute('aria-live', 'polite');
    panel.hidden = true;
    input.form.after(panel);
    let timer, ctrl;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { panel.hidden = true; return; }
      timer = setTimeout(async () => {
        ctrl && ctrl.abort(); ctrl = new AbortController();
        try {
          const url = '/search/suggest.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product,collection,article&resources[limit]=6&resources[options][unavailable_products]=last';
          const res = await fetch(url, { signal: ctrl.signal });
          const r = (await res.json()).resources.results;
          const products = r.products || [], cols = r.collections || [], arts = r.articles || [];
          if (!products.length && !cols.length && !arts.length) {
            panel.innerHTML = '<p class="predictive__empty">No results for “' + esc(q) + '”. Try ‘bed’, ‘sofa’ or ‘mattress’.</p>';
          } else {
            panel.innerHTML =
              (cols.length ? '<div class="predictive__group"><h3>Collections</h3><ul>' + cols.map(c => '<li><a href="' + c.url + '">' + esc(c.title) + '</a></li>').join('') + '</ul></div>' : '') +
              (products.length ? '<div class="predictive__group predictive__group--products"><h3>Products</h3><ul>' + products.map(p =>
                '<li><a class="predictive__product" href="' + p.url + '">' + (p.image ? '<img src="' + p.image + '&width=120" alt="" width="60" height="60" loading="lazy">' : '') +
                '<span>' + esc(p.title) + '<small>' + money(Math.round(parseFloat(p.price) * 100)) + '</small></span></a></li>').join('') + '</ul></div>' : '') +
              (arts.length ? '<div class="predictive__group"><h3>Inspiration</h3><ul>' + arts.map(a => '<li><a href="' + a.url + '">' + esc(a.title) + '</a></li>').join('') + '</ul></div>' : '') +
              '<a class="link predictive__all" href="/search?q=' + encodeURIComponent(q) + '&options[prefix]=last">View all results</a>';
          }
          panel.hidden = false;
        } catch (e) { if (e.name !== 'AbortError') panel.hidden = true; }
      }, 220);
    });
    input.addEventListener('keydown', (e) => { if (e.key === 'Escape') { panel.hidden = true; } });
  }

  /* ---------- Wishlist (saved in this browser) ---------- */
  const KEY = 'loft_wishlist';
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } };
  const write = (list) => { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} sync(); };
  function sync() {
    const list = read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach((b) => {
      const on = list.includes(b.getAttribute('data-wishlist-toggle'));
      b.setAttribute('aria-pressed', String(on));
      b.setAttribute('aria-label', (on ? 'Remove from wishlist: ' : 'Add to wishlist: ') + (b.getAttribute('data-title') || ''));
    });
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => { el.textContent = list.length; el.setAttribute('data-count', list.length); });
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-wishlist-toggle]');
    if (!b) return;
    e.preventDefault();
    const h = b.getAttribute('data-wishlist-toggle');
    const list = read();
    const i = list.indexOf(h);
    i > -1 ? list.splice(i, 1) : list.unshift(h);
    write(list);
    const page = b.closest('[data-wishlist-page]');
    if (page) renderPage(page);
  });
  sync();

  async function renderPage(root) {
    const grid = $('[data-wishlist-grid]', root), empty = $('[data-wishlist-empty]', root);
    const list = read();
    empty.hidden = list.length > 0;
    if (!list.length) { grid.innerHTML = ''; return; }
    const items = await Promise.all(list.map(h => fetch('/products/' + encodeURIComponent(h) + '.js').then(r => r.ok ? r.json() : null).catch(() => null)));
    grid.innerHTML = items.filter(Boolean).map(p => {
      const sale = p.compare_at_price > p.price;
      return '<li><article class="card"><a class="card__media" href="' + p.url + '">' +
        (p.featured_image ? '<img src="' + p.featured_image + '&width=600" alt="" loading="lazy">' : '') + '</a>' +
        '<button type="button" class="icon-button card__wishlist" data-wishlist-toggle="' + esc(p.handle) + '" data-title="' + esc(p.title) + '" aria-pressed="true"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M12 20s-7.5-4.6-9-9.3C2 7.4 4.2 4.5 7.4 4.5c2 0 3.5 1.1 4.6 2.7 1.1-1.6 2.6-2.7 4.6-2.7 3.2 0 5.4 2.9 4.4 6.2-1.5 4.7-9 9.3-9 9.3z"/></svg></button>' +
        '<div class="card__body"><span class="card__type">' + esc(p.type) + '</span><h3 class="card__title"><a href="' + p.url + '">' + esc(p.title) + '</a></h3>' +
        '<div class="price' + (sale ? ' price--on-sale' : '') + '"><span class="price__current">' + (p.price_varies ? 'From ' : '') + money(p.price) + '</span>' + (sale ? '<s class="price__compare">' + money(p.compare_at_price) + '</s>' : '') + '</div></div></article></li>';
    }).join('');
    sync();
  }
  const page = $('[data-wishlist-page]');
  if (page) renderPage(page);
})();
